// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Ouroboros_TsBridge_Branding from "../Ouroboros.TsBridge.Branding/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var UserZipcode = function (x) {
    return x;
};
var tsBridgeUserZipcode = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("UserZipcode")("__brandUserZipcode"));
    }
};
var writeUserZipcode = Simple_JSON.writeForeignString;
var unwrap = function (v) {
    return v;
};
var showUserZipcode = Data_Show.showString;
var readUserZipcode = Simple_JSON.readString;
var ordUserZipcode = Data_Ord.ordString;
var newtypeUserZipcode = {
    Coercible0: function () {
        return undefined;
    }
};
var makeUserZipcode = UserZipcode;
var eqUserZipcode = Data_Eq.eqString;
export {
    UserZipcode,
    makeUserZipcode,
    unwrap,
    newtypeUserZipcode,
    eqUserZipcode,
    ordUserZipcode,
    showUserZipcode,
    readUserZipcode,
    writeUserZipcode,
    tsBridgeUserZipcode
};
//# sourceMappingURL=index.js.map
